module.exports = __webpack_public_path__ + "static/media/29ADMSPC20.d9f7b712.jpg";